import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AdminContext from '../../../context/admin-context';
import { RaffleState } from '../../../interfaces/raffle';
import DashboardBox from '../box';
import PastRaffleItem from './item';

function PastRaffles() {
  const { t } = useTranslation('admin');
  const { raffles } = useContext(AdminContext);

  const items = raffles!.filter(
    (raffle) => raffle.state >= RaffleState.COMPLETED
  );

  items.sort((a, b) => {
    return Number(b.cId) - Number(a.cId);
  });

  return (
    <DashboardBox className="overflow-auto">
      <div className="text-xl font-medium mb-2">{t('past.title')}</div>

      {items!.map((raffle) => (
        <PastRaffleItem raffle={raffle} />
      ))}
    </DashboardBox>
  );
}

export default PastRaffles;
